<template>
  <div v-if="isEnabled" class="email-verification">
    <el-button
      :icon="buttonIcon"
      :class="iconClass"
      circle
      @click="onIconClick"
    />
    <el-dialog
      :visible.sync="showModal"
      :append-to-body="true"
      class="email-verification__dialog"
    >
      <template v-if="isEmailVerified">
        <h3 slot="title" class="email-verification__dialog-title">Email is verified!</h3>
        <p
          class="email-verification__dialog-description"
        >
          some text about verified email
        </p>
      </template>
      <template v-else>
        <h3 slot="title" class="email-verification__dialog-title">Verify your email</h3>
        <p
          class="email-verification__dialog-description"
        >
          some text clarifying email verification
        </p>
        <el-button
          v-loading="isTriggerLoading"
          class="btn-brand email-verification__dialog-send-email"
          @click="onSendEmailClick"
        >
          Request verification email
        </el-button>
        <p>Or submit code from email</p>
        <el-form-item
          prop="oobCode"
          label="Input verification code">
          <el-input
            v-model="oobCode"
            class="email-verification__dialog-input"
            type="text"
          />
        </el-form-item>
        <el-button
          v-loading="isVerificationLoading"
          class="btn-brand email-verification__dialog-submit"
          @click="onSubmitClick"
        >
          Submit Code
        </el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import { EMAIL_VERIFICATION_STAGE_LOADING } from '@/store/modules/emailVerification';

export default {
  props: {
    unverifiedOnly: {
      type: Boolean,
      default: false,
    },
    code: {
      type: String,
      default: '',
    },
  },
  data: () => ({
    oobCode: '',
    showModal: false,
  }),
  computed: {
    ...mapGetters(['isEmailVerified', 'featureFlag']),
    ...mapGetters({
      isAnyLoading: 'emailVerification/isLoading',
      stateVerify: 'emailVerification/stateVerify',
      stateTrigger: 'emailVerification/stateTrigger',
      requestError: 'emailVerification/error',
    }),
    isVerificationLoading() {
      return this.stateVerify === EMAIL_VERIFICATION_STAGE_LOADING;
    },
    isTriggerLoading() {
      return this.stateTrigger === EMAIL_VERIFICATION_STAGE_LOADING;
    },
    isLoading() {
      return this.isEmailVerified === null || this.isAnyLoading;
    },
    buttonIcon() {
      if (this.isEmailVerified) return 'el-icon-circle-check';
      if (this.isLoading) return 'el-icon-loading';
      return 'el-icon-warning';
    },
    iconClass() {
      const res = ['email-verification__icon-button'];
      if (this.isEmailVerified) res.push('email-verification__status-done');
      else if (this.isLoading) res.push('email-verification__status-loading');
      else res.push('email-verification__status-warning');
      return res;
    },
    isFeatureEnabled() {
      return this.featureFlag('email_verification');
    },
    isEnabled() {
      return this.isFeatureEnabled && (!this.unverifiedOnly || this.isEmailVerified === false);
    },
  },
  watch: {
    requestError(val) {
      if (val) this.showErrorMsg(val.message);
    },
  },
  mounted() {
    if (this.isFeatureEnabled && this.code && !this.isEmailVerified) {
      this.verifyEmail(this.code);
    }
  },
  methods: {
    ...mapActions({
      triggerEmailVerification: 'emailVerification/triggerEmailVerification',
      verifyEmail: 'emailVerification/verifyEmail',
    }),
    onIconClick() {
      this.showModal = true;
    },
    onSubmitClick() {
      this.verifyEmail(this.oobCode);
    },
    onSendEmailClick() {
      this.triggerEmailVerification();
    },
  },
};
</script>


<style lang="scss" scoped>
@import "../assets/scss/variables.scss";
.email-verification {
  height: 100%;
  display: flex;
  align-items: center;
  &__icon-button {
    padding: 3px !important;
    font-size: 20px;
    vertical-align: middle;
  }
  &__status-done {
    background-color: #ffffff;
    color: forestgreen;
  }
  &__status-warning {
    background-color: #ffffff;
    color: orange;
  }
  &__status-loading {
    background-color: #ffffff;
    color: gray;
  }
  &__dialog-input {
    padding: 0;
  }
  &__dialog {
    border-radius: 8px;
    /deep/ .el-dialog {
      background-color: $dark-background;
      h3 {
        font-size: 28px;
        margin: 0 0;
        line-height: 36px;
        color: #ffffff;
        font-weight: 500;
      }
      .el-dialog__body {
        text-align: center;
        p {
          margin: 16px 0 32px 0;
          font-weight: 400;
          font-size: 16px;
          line-height: 20px;
          color: #ffffff;
        }
      }
    }
  }
}
</style>
